document.addEventListener("DOMContentLoaded", function () {
  const rsLearning = document.querySelector(".rs-learning");
  if (!rsLearning) return;
  const SUCCESS_ICON_SVG = '<svg t="1781592261537" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4974" width="200" height="200"><path d="M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512-230.4-512-512-512zM409.6 761.6L172.8 544l57.6-64L409.6 640l384-384 64 64-448 441.6z" fill="green" p-id="4975"></path></svg>';
  const allDownloadMessageTimers = new WeakMap();

  const allCategories = rsLearning.querySelectorAll(".rs-main-category");
  const subButtons = rsLearning.querySelectorAll(".sub-category-btn");
  let contentGrids = rsLearning.querySelectorAll(".content-grid");
  const initializedContentGrids = new WeakSet();
  const contentGridRenderers = new WeakMap();
  const loadingContentGrids = new Map();
  let preloadAllContentGridsPromise = Promise.resolve();
  let isPreloadingContentGrids = false;
  let hasPreloadedContentGrids = false;
  let searchRequestId = 0;
  const isHistoricalArchivesBlank = rsLearning.dataset.rsDownloadHistoricalArchivesBlank === "true";
  const configuredHistoricalArchivesUrl = rsLearning.dataset.rsDownloadHistoricalArchivesUrl;
  const historicalArchivesUrl = configuredHistoricalArchivesUrl && !["true", "false"].includes(configuredHistoricalArchivesUrl)
    ? configuredHistoricalArchivesUrl
    : "/pages/historical-archives";

  const searchGrid = document.querySelector(".search-results-grid");
  const searchList = searchGrid?.querySelector(".search-list");
  const noResultsMsg = searchGrid?.querySelector(".rs-no-results-message");
  const searchPagination = searchGrid?.querySelector(".pagination");
  const contentLoader = rsLearning.querySelector("[data-rs-download-content-loader]");
  const searchSubmitButtons = rsLearning.querySelectorAll(".rs-search-submit");
  const learningWrapper = rsLearning.querySelector(".rs-learning-wrapper");
  const historyLoading = rsLearning.querySelector("[data-rs-history-loading]");
  const historyEmpty = rsLearning.querySelector("[data-rs-history-empty]");

  const searchInputs = document.querySelectorAll(
    "#rs-search-input, #rs-search-input-mobile, #rs-search-input-desktop"
  );
  const searchInputDesktop = document.getElementById("rs-search-input");

  const menuToggleLabel = document.querySelector(
    ".rs-menu-toggle .rs-selected-subcat"
  );
  const mobileToggle = document.querySelector(".rs-menu-toggle");
  const mobileClearIcon = document.querySelector(".rs-menu-toggle .clear-icon");
  const firstButton = rsLearning.querySelector(".sub-category-btn");
  const searchTitle = searchGrid?.querySelector(".search-title");

  function refreshContentGrids() {
    contentGrids = rsLearning.querySelectorAll(".content-grid");
    return contentGrids;
  }

  function initProductDetails(container = document) {
    container.querySelectorAll(".product-item").forEach((productItem) => {
      if (productItem.dataset.rsDetailsInitialized === "true") return;
      productItem.dataset.rsDetailsInitialized = "true";

    const allDetails = productItem.querySelectorAll(
      "details-disclosure > details"
    );
    if (!allDetails.length) return;

    allDetails.forEach((details) => {
      details.addEventListener("toggle", (event) => {
        if (details.hasAttribute("open")) {
          if (details.closest(".product-item")?.dataset.allowMultipleOpen === "true") {
            return;
          }

          allDetails.forEach((otherDetails) => {
            if (otherDetails !== details) {
              otherDetails.removeAttribute("open");
            }
          });
        }
      });
    });
    });
  }

  function openDefaultProductListDisclosure(container = document) {
    const productItems = container.matches?.(".product-item")
      ? [container]
      : Array.from(container.querySelectorAll(".product-item"));

    productItems.forEach((productItem) => {
      const firstProductListDetails = productItem.querySelector(".product_list_down.flex")?.closest("details");
      if (firstProductListDetails) firstProductListDetails.setAttribute("open", "");
    });
  }

  function shouldOpenDefaultProductListDisclosure(container) {
    const grid = container?.closest?.(".content-grid") || container;
    return (
      isHistoricalArchivesBlank ||
      grid?.dataset?.historicalArchivesBlank === "true" ||
      grid?.dataset?.rsDownloadHistoricalArchivesBlank === "true"
    );
  }

  initProductDetails(document);
  openDefaultProductListDisclosure(document);

  function scrollToLearningTop() {
    const yOffset = -200;
    const y =
      rsLearning.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }

  function hideAllGrids() {
    refreshContentGrids().forEach((grid) => (grid.style.display = "none"));
    if (searchGrid) searchGrid.style.display = "none";
  }

  function setContentLoading(isLoading) {
    if (!contentLoader) return;
    contentLoader.hidden = !isLoading;
    contentLoader.setAttribute("aria-busy", isLoading ? "true" : "false");
  }

  function setHistoryStatus(state) {
    if (!isHistoricalArchivesBlank) return;
    const isLoading = state === "loading";
    const isEmpty = state === "empty";
    const isReady = state === "ready";

    if (historyLoading) {
      historyLoading.hidden = !isLoading;
      historyLoading.classList.toggle("rs-history-status--visible", isLoading);
    }
    if (historyEmpty) {
      historyEmpty.hidden = !isEmpty;
      historyEmpty.classList.toggle("rs-history-status--visible", isEmpty);
    }
    if (learningWrapper) {
      learningWrapper.hidden = !isReady;
      learningWrapper.classList.toggle("rs-history-ready", isReady);
    }
  }

  function updateFilterMask(tabs) {
    const wrapper = tabs.closest(".rs-filter-tabs-wrap");
    if (!wrapper) return;

    const maxScroll = tabs.scrollWidth - tabs.clientWidth;
    const hasScroll = maxScroll > 1;
    const isScrollEnd = !hasScroll || tabs.scrollLeft >= maxScroll - 10;

    wrapper.classList.toggle("has-scroll", hasScroll);
    wrapper.classList.toggle("is-scroll-end", isScrollEnd);
  }

  function updateFilterMasks(container = rsLearning) {
    container.querySelectorAll(".rs-filter-tabs").forEach(updateFilterMask);
  }

  function resetToDefault() {
    searchInputs.forEach((inp) => (inp.value = ""));
    if (searchGrid) {
      searchGrid.style.display = "none";
      if (searchPagination) searchPagination.style.display = "none";
      if (noResultsMsg) noResultsMsg.style.display = "none";
      if (searchList) searchList.innerHTML = "";
    }
    mobileToggle?.classList.remove("is-search");
    if (searchTitle) searchTitle.innerHTML = `Search Results`;

    const fallbackButton = getFirstAvailableMenuButton() || firstButton;
    if (fallbackButton) {
      if (!openParentCategoryForButton(fallbackButton)) {
        allCategories.forEach((cat) => cat.classList.remove("open"));
      }
      activateSubCategory(fallbackButton, false, true);
    } else {
      allCategories.forEach((cat) => cat.classList.remove("open"));
    }
  }

  function updateParentPdfLoads(container = document) {
    container.querySelectorAll('[data-link-type="parent_pdf_load"]').forEach((parentLoad) => {
      const productLinks = parentLoad.closest(".product-links");
      if (!productLinks) return;

      const total = Array.from(
        productLinks.querySelectorAll("[data-secondary_number]")
      ).reduce((sum, item) => {
        const value =
          item.dataset.secondary_number ||
          item.getAttribute("data-secondary_number");
        return sum + (parseInt(value, 10) || 0);
      }, 0);

      const countSpan = parentLoad.querySelector("h4 span");
      if (countSpan) countSpan.textContent = total;
      parentLoad.dataset.totalFiles = String(total);
      parentLoad.style.display = total > 0 ? "" : "none";
    });
  }

  function getDownloadFileName(link, index) {
    const label = link.textContent.trim();

    try {
      const url = new URL(link.href, window.location.href);
      const urlName = decodeURIComponent(url.pathname.split("/").pop() || "");

      return urlName || label || `download-${index + 1}`;
    } catch (error) {
      return label || `download-${index + 1}`;
    }
  }

  function getImageDownloadFileName(image, index, productName) {
    const fallbackName = productName ? `${productName}-image-${index + 1}` : `product-image-${index + 1}`;
    const rawName = image.filename || fallbackName;

    try {
      const url = new URL(image.url, window.location.href);
      const extension = url.pathname.match(/\.(jpe?g|png|webp|gif|avif)$/i)?.[0] || "";

      return extension && !rawName.toLowerCase().endsWith(extension.toLowerCase())
        ? `${rawName}${extension}`
        : rawName;
    } catch (error) {
      return rawName;
    }
  }

  function getFileExtension(url, contentType, fallback = "") {
    const typeMap = {
      "image/jpeg": ".jpg",
      "image/jpg": ".jpg",
      "image/png": ".png",
      "image/webp": ".webp",
      "image/gif": ".gif",
      "image/avif": ".avif"
    };
    const normalizedType = String(contentType || "").split(";")[0].trim().toLowerCase();

    if (typeMap[normalizedType]) return typeMap[normalizedType];

    try {
      const extension = new URL(url, window.location.href).pathname.match(/\.(jpe?g|png|webp|gif|avif|pdf|zip)$/i);

      if (extension) return extension[0].toLowerCase().replace(".jpeg", ".jpg");
    } catch (error) {
      return fallback;
    }

    return fallback;
  }

  function sanitizeFileName(value) {
    return String(value || "download")
      .trim()
      .replace(/[\\/:*?"<>|]+/g, "-")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "") || "download";
  }

  function sanitizeImageFilePart(value) {
    return sanitizeFileName(value || "product-image").toLowerCase() || "product-image";
  }

  function getUniqueFileName(fileName, usedNames, index) {
    const safeName = sanitizeFileName(fileName || `download-${index + 1}`);
    const extensionMatch = safeName.match(/(\.[a-z0-9]+)$/i);
    const extension = extensionMatch ? extensionMatch[1] : "";
    const baseName = extension ? safeName.slice(0, -extension.length) : safeName;
    let uniqueName = safeName;
    let count = 2;

    while (usedNames.has(uniqueName)) {
      uniqueName = `${baseName}-${count}${extension}`;
      count += 1;
    }

    usedNames.add(uniqueName);
    return uniqueName;
  }

  function getUniqueImageFileName(resource, usedNames, index, contentType) {
    const extension = getFileExtension(resource.url, contentType, ".jpg");
    const baseName = sanitizeImageFilePart(
      String(resource.fileName || `product-image-${index + 1}`).replace(/\.[a-z0-9]+$/i, "")
    );
    let fileName = `${baseName}${extension}`;

    if (usedNames.has(fileName)) {
      fileName = `${baseName}-${index + 1}${extension}`;
    }

    usedNames.add(fileName);
    return fileName;
  }

  function shouldShowDownloadLocationHint() {
    return window.matchMedia("(max-width: 750px)").matches;
  }

  const zipTextEncoder = new TextEncoder();
  const zipCrcTable = (() => {
    const table = new Uint32Array(256);

    for (let index = 0; index < 256; index += 1) {
      let value = index;

      for (let bit = 0; bit < 8; bit += 1) {
        value = (value & 1) ? (0xedb88320 ^ (value >>> 1)) : (value >>> 1);
      }

      table[index] = value >>> 0;
    }

    return table;
  })();

  function getZipCrc32(bytes) {
    let crc = 0xffffffff;

    for (let index = 0; index < bytes.length; index += 1) {
      crc = zipCrcTable[(crc ^ bytes[index]) & 0xff] ^ (crc >>> 8);
    }

    return (crc ^ 0xffffffff) >>> 0;
  }

  function writeZipUint16(view, offset, value) {
    view.setUint16(offset, value, true);
  }

  function writeZipUint32(view, offset, value) {
    view.setUint32(offset, value >>> 0, true);
  }

  function getZipDosDateTime(date = new Date()) {
    return {
      dosTime: (date.getHours() << 11) | (date.getMinutes() << 5) | Math.floor(date.getSeconds() / 2),
      dosDate: ((date.getFullYear() - 1980) << 9) | ((date.getMonth() + 1) << 5) | date.getDate()
    };
  }

  function createZipBlob(files) {
    const localParts = [];
    const centralParts = [];
    let offset = 0;
    const { dosDate, dosTime } = getZipDosDateTime();

    files.forEach((file) => {
      const nameBytes = zipTextEncoder.encode(file.path);
      const dataBytes = new Uint8Array(file.buffer);
      const crc = getZipCrc32(dataBytes);
      const localHeader = new ArrayBuffer(30 + nameBytes.length);
      const localView = new DataView(localHeader);

      writeZipUint32(localView, 0, 0x04034b50);
      writeZipUint16(localView, 4, 20);
      writeZipUint16(localView, 6, 0x0800);
      writeZipUint16(localView, 8, 0);
      writeZipUint16(localView, 10, dosTime);
      writeZipUint16(localView, 12, dosDate);
      writeZipUint32(localView, 14, crc);
      writeZipUint32(localView, 18, dataBytes.byteLength);
      writeZipUint32(localView, 22, dataBytes.byteLength);
      writeZipUint16(localView, 26, nameBytes.length);
      writeZipUint16(localView, 28, 0);
      new Uint8Array(localHeader, 30).set(nameBytes);

      localParts.push(localHeader, dataBytes);

      const centralHeader = new ArrayBuffer(46 + nameBytes.length);
      const centralView = new DataView(centralHeader);

      writeZipUint32(centralView, 0, 0x02014b50);
      writeZipUint16(centralView, 4, 20);
      writeZipUint16(centralView, 6, 20);
      writeZipUint16(centralView, 8, 0x0800);
      writeZipUint16(centralView, 10, 0);
      writeZipUint16(centralView, 12, dosTime);
      writeZipUint16(centralView, 14, dosDate);
      writeZipUint32(centralView, 16, crc);
      writeZipUint32(centralView, 20, dataBytes.byteLength);
      writeZipUint32(centralView, 24, dataBytes.byteLength);
      writeZipUint16(centralView, 28, nameBytes.length);
      writeZipUint16(centralView, 30, 0);
      writeZipUint16(centralView, 32, 0);
      writeZipUint16(centralView, 34, 0);
      writeZipUint16(centralView, 36, 0);
      writeZipUint32(centralView, 38, 0);
      writeZipUint32(centralView, 42, offset);
      new Uint8Array(centralHeader, 46).set(nameBytes);

      centralParts.push(centralHeader);
      offset += localHeader.byteLength + dataBytes.byteLength;
    });

    const centralSize = centralParts.reduce((sum, part) => sum + part.byteLength, 0);
    const endHeader = new ArrayBuffer(22);
    const endView = new DataView(endHeader);

    writeZipUint32(endView, 0, 0x06054b50);
    writeZipUint16(endView, 4, 0);
    writeZipUint16(endView, 6, 0);
    writeZipUint16(endView, 8, files.length);
    writeZipUint16(endView, 10, files.length);
    writeZipUint32(endView, 12, centralSize);
    writeZipUint32(endView, 16, offset);
    writeZipUint16(endView, 20, 0);

    return new Blob([...localParts, ...centralParts, endHeader], { type: "application/zip" });
  }

  function canSaveToFolder() {
    return window.isSecureContext && "showDirectoryPicker" in window;
  }

  function getImagesFromZipButton(button) {
    try {
      const images = JSON.parse(button.dataset.images || "[]");
      return Array.isArray(images) ? images.filter((image) => image && image.url) : [];
    } catch (error) {
      console.error("Unable to read product images.", error);
      return [];
    }
  }

  function collectImagesFromZipButton(button, startIndex) {
    const images = getImagesFromZipButton(button);
    const productName = button.dataset.productTitle || button.dataset.productHandle || "";
    const imageFolderName = `${sanitizeImageFilePart(productName || "product")}-images`;

    return images.map((image, index) => ({
      url: image.url,
      fileName: getImageDownloadFileName(image, startIndex + index, productName),
      folderName: imageFolderName,
      type: "image"
    }));
  }

  function collectLinkedResources(productLinks) {
    const resources = [];
    let imageDownloadIndex = 0;

    productLinks
      .querySelectorAll(
        'a.disclosure__toggle[href]:not([href="#"]), a.pdf_background_block[href]:not([href="#"]), button.disclosure__toggle.rs-image-zip-btn, .rs-image-download-ui button.rs-image-zip-btn'
      )
      .forEach((downloadItem, index) => {
        if (downloadItem.matches("button.rs-image-zip-btn")) {
          const images = collectImagesFromZipButton(downloadItem, imageDownloadIndex);
          imageDownloadIndex += images.length;
          resources.push(...images);
          return;
        }

        const href = downloadItem.getAttribute("href");
        if (!href) return;
        resources.push({
          url: href,
          fileName: getDownloadFileName(downloadItem, index),
          type: "file"
        });
      });

    return resources;
  }

  function getResourceFolderName(parentLoad) {
    const productItem = parentLoad.closest(".product-item");
    const title = productItem?.querySelector(".title_main")?.textContent || "download-resources";

    // Match the image button's short title and leave room for nested image paths on Windows.
    const shortTitle = title.split("|")[0].trim();
    return `${sanitizeFileName(shortTitle).slice(0, 80).replace(/[. -]+$/g, "")}-resources`;
  }

  async function saveResourceToFolder(directory, resource, index, usedNames) {
    const response = await fetch(resource.url, { credentials: "omit" });

    if (!response.ok) {
      throw new Error(`Resource request failed: ${response.status}`);
    }

    const targetDirectory = resource.folderName
      ? await directory.getDirectoryHandle(resource.folderName, { create: true })
      : directory;
    const usedKey = resource.folderName || "__root__";
    const folderUsedNames = usedNames.get(usedKey) || new Set();
    const contentType = response.headers.get("content-type");
    const fileName = resource.type === "image"
      ? getUniqueImageFileName(resource, folderUsedNames, index, contentType)
      : getUniqueFileName(resource.fileName, folderUsedNames, index);
    const fileHandle = await targetDirectory.getFileHandle(fileName, { create: true });
    const writable = await fileHandle.createWritable();

    usedNames.set(usedKey, folderUsedNames);
    await writable.write(await response.blob());
    await writable.close();
  }

  async function saveResourcesToFolder(parentLoad, resources) {
    const rootDirectory = await window.showDirectoryPicker({ mode: "readwrite" });
    const resourceDirectory = await rootDirectory.getDirectoryHandle(
      getResourceFolderName(parentLoad),
      { create: true }
    );
    const usedNames = new Map();
    const failedResources = [];

    for (let index = 0; index < resources.length; index += 1) {
      try {
        await saveResourceToFolder(resourceDirectory, resources[index], index, usedNames);
      } catch (error) {
        console.error("Unable to save download resource.", error);
        failedResources.push(resources[index]);
      }
    }

    return failedResources;
  }

  function downloadBlob(blob, fileName) {
    const downloadLink = document.createElement("a");
    const objectUrl = URL.createObjectURL(blob);

    downloadLink.href = objectUrl;
    downloadLink.download = fileName;
    downloadLink.rel = "noopener";
    downloadLink.style.display = "none";

    document.body.appendChild(downloadLink);
    downloadLink.click();
    downloadLink.remove();
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
  }

  async function downloadResourcesAsZip(parentLoad, resources) {
    const usedNames = new Map();
    const files = [];

    for (let index = 0; index < resources.length; index += 1) {
      const resource = resources[index];
      const response = await fetch(resource.url, { credentials: "omit" });

      if (!response.ok) {
        throw new Error(`Resource request failed: ${response.status}`);
      }

      const usedKey = resource.folderName || "__root__";
      const folderUsedNames = usedNames.get(usedKey) || new Set();
      const contentType = response.headers.get("content-type");
      const fileName = resource.type === "image"
        ? getUniqueImageFileName(resource, folderUsedNames, index, contentType)
        : getUniqueFileName(resource.fileName, folderUsedNames, index);
      const folderName = resource.folderName ? `${sanitizeFileName(resource.folderName)}/` : "";

      usedNames.set(usedKey, folderUsedNames);
      files.push({
        path: `${folderName}${fileName}`,
        buffer: await response.arrayBuffer()
      });
    }

    downloadBlob(createZipBlob(files), `${getResourceFolderName(parentLoad)}.zip`);
  }

  function getAllDownloadMessage(parentLoad) {
    let message = parentLoad.querySelector("[data-all-download-message]");

    if (message) return message;

    message = document.createElement("span");
    message.className = "rs-image-download-message";
    message.setAttribute("data-all-download-message", "");
    message.setAttribute("role", "status");
    message.setAttribute("aria-live", "polite");
    message.hidden = true;
    parentLoad.appendChild(message);

    return message;
  }

  function hideAllDownloadMessage(parentLoad) {
    const message = parentLoad.querySelector("[data-all-download-message]");
    const timer = allDownloadMessageTimers.get(parentLoad);

    if (timer) {
      window.clearTimeout(timer);
      allDownloadMessageTimers.delete(parentLoad);
    }

    if (!message) return;

    message.classList.remove("is-visible");
    message.hidden = true;
  }

  function showAllDownloadMessage(parentLoad, html, autoHide = false) {
    const message = getAllDownloadMessage(parentLoad);

    hideAllDownloadMessage(parentLoad);
    message.innerHTML = html;
    message.hidden = false;
    message.classList.add("is-visible");

    if (autoHide) {
      allDownloadMessageTimers.set(parentLoad, window.setTimeout(() => {
        message.classList.remove("is-visible");
        message.hidden = true;
        allDownloadMessageTimers.delete(parentLoad);
      }, 2000));
    }
  }

  function setAllDownloadState(parentLoad, state, locationMessage) {
    const toggle = parentLoad.querySelector(".disclosure__toggle");
    const isLoading = state === "loading";

    toggle.classList.toggle("is-loading", isLoading);
    toggle.setAttribute("aria-busy", isLoading ? "true" : "false");
    if (toggle) {
      toggle.style.pointerEvents = isLoading ? "none" : "";
      toggle.setAttribute("aria-disabled", isLoading ? "true" : "false");
    }

    if (state === "complete") {
      const fallbackLocationMessage = canSaveToFolder()
        ? "Saved to the folder you selected."
        : "Find the ZIP in your browser Downloads.";
      const messageHtml = shouldShowDownloadLocationHint()
        ? `${SUCCESS_ICON_SVG}<span>Download complete.<br>${locationMessage || fallbackLocationMessage}</span>`
        : `${SUCCESS_ICON_SVG}<span>Download complete.</span>`;
      showAllDownloadMessage(parentLoad, messageHtml, true);
    } else if (state === "error") {
      showAllDownloadMessage(parentLoad, "<span>Some resources could not be downloaded.<br>Please try again.</span>");
    } else {
      hideAllDownloadMessage(parentLoad);
    }
  }

  async function downloadLinkedResources(parentLoad) {
    const productLinks = parentLoad.closest(".product-links");
    if (!productLinks) return;
    const resources = collectLinkedResources(productLinks);

    if (!resources.length) return;
    if (parentLoad.querySelector(".disclosure__toggle")?.classList.contains("is-loading")) return;

    setAllDownloadState(parentLoad, "loading");

    try {
      if (!canSaveToFolder()) {
        await downloadResourcesAsZip(parentLoad, resources);
        setAllDownloadState(parentLoad, "complete", "Find the ZIP in your browser Downloads.");
        return;
      }

      const failedResources = await saveResourcesToFolder(parentLoad, resources);
      setAllDownloadState(parentLoad, failedResources.length ? "error" : "complete");
    } catch (error) {
      if (error && error.name === "AbortError") {
        setAllDownloadState(parentLoad, "idle");
        return;
      }
      console.error("Unable to download product resources.", error);
      setAllDownloadState(parentLoad, "error");
    }
  }

  rsLearning.addEventListener("click", async (event) => {
    const downloadArea = event.target.closest(".rs-toggle-download");
    if (!downloadArea) return;

    if (downloadArea.classList.contains("all_downloads")) {
      event.preventDefault();
      await downloadLinkedResources(downloadArea);
      return;
    }

    const imageZipButton = downloadArea.querySelector(".rs-image-zip-btn");
    if (!imageZipButton || event.target.closest(".rs-image-zip-btn")) return;

    event.preventDefault();
    if (typeof window.richSolarDownloadImageZip === "function") {
      await window.richSolarDownloadImageZip(imageZipButton);
    } else {
      imageZipButton.click();
    }
  });

  updateParentPdfLoads(rsLearning);

  allCategories.forEach((categoryEl) => {
    const header = categoryEl.querySelector(".rs-cat-header");
    if (!header) return;
    header.addEventListener("click", () => {
      const willOpen = !categoryEl.classList.contains("open");
      allCategories.forEach((cat) => cat.classList.remove("open"));
      if (willOpen) categoryEl.classList.add("open");
    });
  });

  function findContentGrid(category, tab) {
    if (category) {
      return rsLearning.querySelector(
        `.content-grid[data-category="${category}"][data-tab="${tab}"]`
      );
    }

    return rsLearning.querySelector(
      `.content-grid[data-tab="${tab}"]`
    );
  }

  function buildLazyGridUrl(collectionHandle, recentOnly) {
    const view = isHistoricalArchivesBlank
      ? (recentOnly ? "rs-download-resources-recent" : "rs-download-resources")
      : (recentOnly ? "rs-download-resources-current-recent" : "rs-download-resources-current");
    const url = new URL(`/collections/${encodeURIComponent(collectionHandle)}`, window.location.origin);
    url.searchParams.set("view", view);
    return url.toString();
  }

  function getGridParamsFromButton(button) {
    if (!button) return null;
    const { category, tab } = button.dataset;
    if (!tab) return null;

    return {
      category,
      tab,
      collectionHandle: button.dataset.collection || tab,
      recentOnly: button.dataset.recentOnly === "true"
    };
  }

  function getGridForButton(button) {
    const params = getGridParamsFromButton(button);
    return params ? findContentGrid(params.category, params.tab) : null;
  }

  function gridHasProducts(grid) {
    return Boolean(grid?.querySelector(".product-item"));
  }

  function setButtonMenuVisibility(button, isVisible) {
    const item = button.closest("li");
    if (item) item.hidden = !isVisible;
  }

  function syncHistoricalArchiveMenuVisibility() {
    if (!isHistoricalArchivesBlank) return;

    Array.from(subButtons).forEach((button) => {
      setButtonMenuVisibility(button, gridHasProducts(getGridForButton(button)));
    });

    allCategories.forEach((category) => {
      if (!category.closest(".rs-menu")) return;
      const hasVisibleSubButton = Array.from(category.querySelectorAll(".sub-category-btn"))
        .some((button) => !button.closest("li")?.hidden);
      category.hidden = !hasVisibleSubButton;
      category.classList.toggle("open", hasVisibleSubButton && category.classList.contains("open"));
    });
  }

  function getFirstVisibleMenuButton() {
    return Array.from(subButtons).find((button) => {
      if (button.closest("li")?.hidden) return false;
      if (button.closest(".rs-main-category")?.hidden) return false;
      return gridHasProducts(getGridForButton(button));
    });
  }

  function getFirstAvailableMenuButton() {
    return Array.from(subButtons).find((button) => {
      if (button.closest("li")?.hidden) return false;
      if (button.closest(".rs-main-category")?.hidden) return false;
      return true;
    });
  }

  function openParentCategoryForButton(button) {
    const parentCategory = button?.closest(".rs-main-category");
    if (!parentCategory) return false;

    allCategories.forEach((cat) => cat.classList.remove("open"));
    parentCategory.classList.add("open");
    return true;
  }

  async function revealHistoricalArchiveContent() {
    if (!isHistoricalArchivesBlank) return;

    syncHistoricalArchiveMenuVisibility();
    const firstVisibleButton = getFirstVisibleMenuButton();
    if (firstVisibleButton) {
      await activateSubCategory(firstVisibleButton, false);
      setHistoryStatus("ready");
    } else {
      hideAllGrids();
      setContentLoading(false);
      setHistoryStatus("empty");
    }
  }

  async function loadContentGrid(category, tab, collectionHandle, recentOnly) {
    if (!collectionHandle || !tab) return null;

    const cacheKey = `${category || ""}::${tab}::${collectionHandle}::${recentOnly ? "recent" : "all"}`;
    if (loadingContentGrids.has(cacheKey)) return loadingContentGrids.get(cacheKey);

    async function fetchGridHtml(hasRetried = false) {
      try {
        const response = await fetch(buildLazyGridUrl(collectionHandle, recentOnly), {
          headers: { "X-Requested-With": "XMLHttpRequest" }
        });
        if (!response.ok) throw new Error("Unable to load download resources.");
        const html = await response.text();
        const template = document.createElement("template");
        template.innerHTML = html.trim();
        const grid = template.content.querySelector(".content-grid");
        if (!grid) throw new Error("Download resources were not found.");
        return grid;
      } catch (error) {
        if (!hasRetried) return fetchGridHtml(true);
        throw error;
      }
    }

    const promise = fetchGridHtml()
      .then((grid) => {
        grid.dataset.category = category || "";
        grid.dataset.tab = tab;
        grid.dataset.paginationSize = rsLearning.querySelector(".search-results-grid")?.dataset.paginationSize || grid.dataset.paginationSize;
        grid.dataset.historicalArchivesBlank = isHistoricalArchivesBlank ? "true" : "false";
        const historyLink = grid.querySelector(".rs-selected-history");
        if (historyLink && historicalArchivesUrl) historyLink.href = historicalArchivesUrl;

        const searchResultsGrid = rsLearning.querySelector(".search-results-grid");
        if (searchResultsGrid) {
          searchResultsGrid.before(grid);
        } else {
          rsLearning.querySelector(".content-grid-right")?.appendChild(grid);
        }

        refreshContentGrids();
        initProductDetails(grid);
        updateParentPdfLoads(grid);
        initContentGrid(grid);
        openDefaultProductListDisclosure(grid);
        grid.querySelectorAll(".rs-filter-tabs").forEach((tabs) => {
          tabs.addEventListener("scroll", () => updateFilterMask(tabs), { passive: true });
        });
        return grid;
      })
      .catch((error) => {
        console.error(error);
        return null;
      })
      .finally(() => {
        loadingContentGrids.delete(cacheKey);
      });

    loadingContentGrids.set(cacheKey, promise);
    return promise;
  }

  async function showContentGrid(category, tab) {
    hideAllGrids();

    const activeButton = category
      ? rsLearning.querySelector(`.rs-menu .sub-category-btn[data-category="${category}"][data-tab="${tab}"]`)
      : rsLearning.querySelector(`.rs-menu .sub-category-btn[data-tab="${tab}"]:not([data-category])`);
    const params = getGridParamsFromButton(activeButton) || {
      category,
      tab,
      collectionHandle: tab,
      recentOnly: false
    };
    let newActiveGrid = findContentGrid(category, tab);
    if (!newActiveGrid) {
      setContentLoading(true);
      newActiveGrid = await loadContentGrid(
        params.category,
        params.tab,
        params.collectionHandle,
        params.recentOnly
      );
    }

    setContentLoading(false);
    if (newActiveGrid) {
      hideAllGrids();
      newActiveGrid.style.display = "block";
      requestAnimationFrame(() => updateFilterMasks(newActiveGrid));
    }
  }

  rsLearning.querySelectorAll(".rs-filter-tabs").forEach((tabs) => {
    tabs.addEventListener("scroll", () => updateFilterMask(tabs), { passive: true });
  });

  window.addEventListener("resize", () => updateFilterMasks(), { passive: true });

  async function activateSubCategory(button, shouldScroll = true, forceOpenParent = false) {
    const { category, tab } = button.dataset;
    subButtons.forEach((b) => b.classList.remove("active"));
    button.classList.add("active");

    allCategories.forEach((cat) => cat.classList.remove("open"));

    const parentCategory = button.closest(".rs-main-category");
    if (parentCategory && (window.innerWidth >= 750 || forceOpenParent)) {
      parentCategory.classList.add("open");
    }

    await showContentGrid(category, tab);

    if (menuToggleLabel)
      menuToggleLabel.textContent = button.textContent.trim();
    mobileToggle?.classList.remove("is-search");

    if (searchInputDesktop) searchInputDesktop.value = "";

    if (shouldScroll) {
      scrollToLearningTop();
    }
  }

  subButtons.forEach((btn) => {
    btn.addEventListener("click", function (event) {
      activateSubCategory(this, event.isTrusted);
    });
  });

  if (firstButton) {
    activateSubCategory(firstButton, false);
  }

  function preloadContentGrids() {
    if (isPreloadingContentGrids) return preloadAllContentGridsPromise;
    if (hasPreloadedContentGrids) return preloadAllContentGridsPromise;

    const preloadButtons = Array.from(subButtons).filter((button) => {
      const params = getGridParamsFromButton(button);
      return params && !findContentGrid(params.category, params.tab);
    });
    if (!preloadButtons.length) {
      isPreloadingContentGrids = false;
      hasPreloadedContentGrids = true;
      preloadAllContentGridsPromise = Promise.resolve();
      revealHistoricalArchiveContent();
      return preloadAllContentGridsPromise;
    }

    isPreloadingContentGrids = true;
    setHistoryStatus("loading");
    let nextIndex = 0;
    const concurrency = 2;

    async function worker() {
      while (nextIndex < preloadButtons.length) {
        const button = preloadButtons[nextIndex];
        nextIndex += 1;
        const params = getGridParamsFromButton(button);
        if (!params || findContentGrid(params.category, params.tab)) continue;

        await loadContentGrid(
          params.category,
          params.tab,
          params.collectionHandle,
          params.recentOnly
        );
      }
    }

    preloadAllContentGridsPromise = Promise.all(Array.from({ length: Math.min(concurrency, preloadButtons.length) }, worker))
      .catch((error) => {
        console.error(error);
      })
      .finally(async () => {
        isPreloadingContentGrids = false;
        hasPreloadedContentGrids = true;
        await revealHistoricalArchiveContent();
      });
    return preloadAllContentGridsPromise;
  }

  const schedulePreload = window.requestIdleCallback || ((callback) => window.setTimeout(callback, 300));
  schedulePreload(preloadContentGrids);

  function initContentGrid(grid) {
    if (!grid || initializedContentGrids.has(grid)) return;

    const filterButtons = grid.querySelectorAll(".filter-btn");
    const pagination = grid.querySelector(".pagination");
    const noResults = grid.querySelector(".rs-no-results-message");
    const isHistoricalArchivesBlank = grid.dataset.historicalArchivesBlank === "true";
    const getItems = () => Array.from(grid.querySelectorAll(".product-item"));

    if (!getItems().length || !pagination) return;
    initializedContentGrids.add(grid);

    const initialProductCount = parseInt(grid.dataset.paginationSize, 10) || 2;
    let visibleProductCount = initialProductCount;
    let activeFilter = "all";
    const productLevelFilters = new Set(["discontinued", "previous"]);

    function isProductLevelFilter() {
      return productLevelFilters.has(activeFilter);
    }

    function getFilteredItems() {
      return getItems().filter((item) => {
        return activeFilter === "all" || item.dataset[activeFilter] === "true";
      });
    }

    function renderShowMorePagination(totalItems, shownItems) {
      pagination.innerHTML = "";
      pagination.classList.add("pagination--show-more");

      if (totalItems <= 0 || shownItems >= totalItems) {
        pagination.style.display = "none";
        return;
      }

      pagination.style.display = "";

      const status = document.createElement("p");
      status.className = "pagination__status";
      status.textContent = `Showing ${shownItems} of ${totalItems}`;
      pagination.appendChild(status);

      const progress = document.createElement("div");
      progress.className = "pagination__progress";

      const progressBar = document.createElement("span");
      progressBar.style.width = `${Math.min(
        100,
        (shownItems / totalItems) * 100
      )}%`;
      progress.appendChild(progressBar);
      pagination.appendChild(progress);

      const showMoreBtn = document.createElement("button");
      showMoreBtn.type = "button";
      showMoreBtn.className = "pagination__show-more";
      showMoreBtn.textContent = "Show More";
      showMoreBtn.addEventListener("click", () => {
        visibleProductCount += initialProductCount;
        showPage();
      });
      pagination.appendChild(showMoreBtn);
    }

    function filterProductResources(item) {
      const productLinks = item.querySelector(".product-links");
      if (!productLinks) return;
      if (isProductLevelFilter()) {
        item.dataset.allowMultipleOpen = "false";
        item.querySelectorAll("[data-link-type], details-disclosure").forEach((element) => {
          element.style.display = "";
        });
        item.querySelectorAll("details-disclosure > details").forEach((details) => {
          details.removeAttribute("open");
        });
        return;
      }

      item.dataset.allowMultipleOpen = activeFilter === "all" ? "false" : "true";

      productLinks.querySelectorAll('[data-link-type="parent_pdf_load"]').forEach((parentLoad) => {
        const totalFiles = parseInt(parentLoad.dataset.totalFiles, 10) || 0;
        parentLoad.style.display = activeFilter === "all" && totalFiles > 0 ? "" : "none";
      });

      Array.from(productLinks.children).forEach((child) => {
        if (
          !child.matches("[data-link-type]") ||
          child.dataset.linkType === "parent_pdf_load"
        ) {
          return;
        }

        child.style.display =
          activeFilter === "all" || child.dataset.linkType === activeFilter
            ? ""
            : "none";
      });

      productLinks.querySelectorAll(".pdf_background_block[data-link-type]").forEach((block) => {
        block.style.display =
          activeFilter === "all" || block.dataset.linkType === activeFilter
            ? ""
            : "none";
      });

      productLinks.querySelectorAll("details-disclosure").forEach((disclosure) => {
        const details = disclosure.querySelector("details");
        const pdfBlocks = Array.from(
          disclosure.querySelectorAll(".pdf_background_block[data-link-type]")
        );
        const videoBlock = disclosure.querySelector('[data-link-type="videos"]');
        const hasMatchingPdf = pdfBlocks.some(
          (block) => block.dataset.linkType === activeFilter
        );
        const hasMatchingVideo = activeFilter === "videos" && Boolean(videoBlock);

        let shouldShow = activeFilter === "all" || hasMatchingPdf || hasMatchingVideo;
        disclosure.style.display = shouldShow ? "" : "none";

        if (!details) return;

        if (activeFilter === "all") {
          details.removeAttribute("open");
        } else if (hasMatchingPdf || hasMatchingVideo) {
          details.setAttribute("open", "");
        } else {
          details.removeAttribute("open");
        }
      });
    }

    function showPage() {
      const filteredItems = getFilteredItems();

      getItems().forEach((item) => (item.style.display = "none"));

      const itemsToShow = filteredItems.slice(0, visibleProductCount);
      const shownProductCount = Math.min(
        visibleProductCount,
        filteredItems.length
      );

      itemsToShow.forEach((item) => {
        item.style.display = "";

        filterProductResources(item);
      });

      if (shouldOpenDefaultProductListDisclosure(grid)) {
        itemsToShow.forEach((item) => openDefaultProductListDisclosure(item));
      }

      renderShowMorePagination(filteredItems.length, shownProductCount);

      if (noResults) {
        if (filteredItems.length === 0) {
            noResults.style.display = "block";
            pagination.style.display = "none"; 
        } else {
            noResults.style.display = "none";
            pagination.style.display = shownProductCount < filteredItems.length ? "" : "none";
        }
      }
    }

    filterButtons.forEach((btn) => {
      btn.addEventListener("click", function (event) {
        filterButtons.forEach((b) => b.classList.remove("active"));
        this.classList.add("active");
        activeFilter = this.dataset.filter;
        visibleProductCount = initialProductCount;
        showPage();

        if (event.isTrusted) {
          this.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
          window.setTimeout(() => updateFilterMask(this.closest(".rs-filter-tabs")), 250);
          scrollToLearningTop();
        } else {
          updateFilterMask(this.closest(".rs-filter-tabs"));
        }
      });
    });

    showPage();
    contentGridRenderers.set(grid, showPage);
    openDefaultProductListDisclosure(grid);
  }

  refreshContentGrids().forEach(initContentGrid);
  rsLearning.addEventListener("rs:content-grid-updated", (event) => {
    const grid = event.detail?.grid;
    if (!grid) return;

    initContentGrid(grid);
    contentGridRenderers.get(grid)?.();
    openDefaultProductListDisclosure(grid);
  });
  openDefaultProductListDisclosure(rsLearning);

  function performSearch(query) {
    if (!searchGrid || !searchList || !searchPagination) return;

    const filter = (query || "").toLowerCase().trim();

    if (filter === "") {
      resetToDefault();
      return;
    }

    if (searchTitle) {
      searchTitle.innerHTML = `Search Results for "<span class="search-query-highlight">${filter}</span>"`;
    }

    refreshContentGrids().forEach((grid) => (grid.style.display = "none"));
    searchGrid.style.display = "block";
    searchList.innerHTML = "";
    mobileToggle?.classList.add("is-search");
    rsLearning
      .querySelectorAll(".rs-menu-list button.active")
      .forEach((button) => button.classList.remove("active"));
    if (menuToggleLabel) menuToggleLabel.textContent = `Search: ${filter}`;

    allCategories.forEach((cat) => cat.classList.remove("open"));

    let matches = [];
    const matchedProductIds = new Set();
    const searchPageSize = parseInt(searchGrid.dataset.paginationSize, 10) || 2;
    let visibleSearchCount = searchPageSize;

    function resetSearchResultItem(item) {
      item.style.display = "";
      item.dataset.allowMultipleOpen = "false";
      item.querySelectorAll("[data-link-type], details-disclosure").forEach((element) => {
        element.style.display = "";
      });
      item.querySelectorAll("details-disclosure > details").forEach((details) => {
        details.removeAttribute("open");
      });
      return item;
    }

    document.querySelectorAll(".product-item").forEach((item) => {
      const productId = item.dataset.productId;
      const uniqueKey =
        productId ||
        [
          item.querySelector(".title_main")?.textContent || "",
          item.querySelector(".title_sub")?.textContent || ""
        ].join("|").trim().toLowerCase();

      if (uniqueKey && matchedProductIds.has(uniqueKey)) return;

      const productSearchText = [
        item.querySelector(".title_main")?.textContent || "",
        item.querySelector(".title_sub")?.textContent || ""
      ].join(" ");
      const text = productSearchText.toLowerCase();

      if (text.includes(filter)) {
        if (uniqueKey) matchedProductIds.add(uniqueKey);
        matches.push(resetSearchResultItem(item.cloneNode(true)));
      }
    });

    function renderSearchPagination(totalItems, shownItems) {
      searchPagination.innerHTML = "";
      searchPagination.classList.add("pagination--show-more");

      if (totalItems <= 0 || shownItems >= totalItems) {
        searchPagination.style.display = "none";
        return;
      }

      searchPagination.style.display = "flex";

      const status = document.createElement("p");
      status.className = "pagination__status";
      status.textContent = `Showing ${shownItems} of ${totalItems}`;
      searchPagination.appendChild(status);

      const progress = document.createElement("div");
      progress.className = "pagination__progress";

      const progressBar = document.createElement("span");
      progressBar.style.width = `${Math.min(100, (shownItems / totalItems) * 100)}%`;
      progress.appendChild(progressBar);
      searchPagination.appendChild(progress);

      const showMoreBtn = document.createElement("button");
      showMoreBtn.type = "button";
      showMoreBtn.className = "pagination__show-more";
      showMoreBtn.textContent = "Show More";
      showMoreBtn.addEventListener("click", () => {
        visibleSearchCount += searchPageSize;
        renderSearchResults();
      });
      searchPagination.appendChild(showMoreBtn);
    }

    function renderSearchResults() {
      searchList.innerHTML = "";
      const shownSearchCount = Math.min(visibleSearchCount, matches.length);

      matches.slice(0, shownSearchCount).forEach((item) => {
        if (item.classList.contains("product-item")) {
          item.querySelectorAll("details-disclosure > details").forEach(details => {
              details.removeAttribute("open");
          });
          if (shouldOpenDefaultProductListDisclosure(searchGrid)) {
            openDefaultProductListDisclosure(item);
          }
        }
        searchList.appendChild(item);
      });
      renderSearchPagination(matches.length, shownSearchCount);
    }

    if (matches.length > 0) {
      noResultsMsg.style.display = "none";
      visibleSearchCount = searchPageSize;
      renderSearchResults();
    } else {
      noResultsMsg.style.display = "flex";
      searchPagination.style.display = "none"; 
    }
  }

  function setSearchLoading(isLoading) {
    searchSubmitButtons.forEach((button) => {
      button.classList.toggle("is-loading", isLoading);
      button.setAttribute("aria-busy", isLoading ? "true" : "false");
    });
  }

  async function searchWhenReady(query) {
    const requestId = ++searchRequestId;
    if (!hasPreloadedContentGrids) {
      setSearchLoading(true);
      try {
        preloadContentGrids();
        await preloadAllContentGridsPromise;
      } finally {
        if (requestId === searchRequestId) setSearchLoading(false);
      }
      if (requestId !== searchRequestId) return;
    }
    performSearch(query);
  }

  if (searchInputs.length) {
    searchInputs.forEach((inp) => {
      inp.addEventListener("keyup", function () {
        searchWhenReady(this.value);
      });
    });
  }

  if (mobileClearIcon) {
    mobileClearIcon.addEventListener("click", (e) => {
      e.stopPropagation();
      resetToDefault();
    });
  }

  const popup = document.querySelector(".rs-menu-popup");
  if (mobileToggle && popup) {
    const popupContent = popup.querySelector(".rs-menu-popup-content");
    const closeBtn = popup.querySelector(".rs-menu-close");
    const okBtn = popup.querySelector(".rs-menu-ok");
    const desktopMenu = rsLearning.querySelector(".rs-menu .rs-menu-list");

    mobileToggle.addEventListener("click", () => {
      if (mobileToggle.classList.contains("is-search")) return;

      if (!desktopMenu) return;
      popupContent.innerHTML = "";
      const clonedMenu = desktopMenu.cloneNode(true);
      popupContent.appendChild(clonedMenu);

      const activeDesktopButton = rsLearning.querySelector(
        ".rs-menu .sub-category-btn.active"
      );

      clonedMenu.querySelectorAll(".rs-main-category").forEach(c => c.classList.remove("open"));

      if (activeDesktopButton) {
        const { category: activeCat, tab: activeTab } =
          activeDesktopButton.dataset;
        const buttonToActivate = activeCat
          ? clonedMenu.querySelector(
              `.sub-category-btn[data-category="${activeCat}"][data-tab="${activeTab}"]`
            )
          : clonedMenu.querySelector(
              `.sub-category-btn[data-tab="${activeTab}"]:not([data-category])`
            );
        if (buttonToActivate) {
          buttonToActivate.classList.add("active");
        }
      }

      clonedMenu.querySelectorAll(".rs-cat-header").forEach((header) => {
        header.addEventListener("click", (e) => {
          e.stopPropagation();
          const parentCat = header.parentElement;
          clonedMenu.querySelectorAll(".rs-main-category").forEach((c) => {
            if (c !== parentCat) c.classList.remove("open");
          });
          parentCat.classList.toggle("open");
        });
      });

      clonedMenu.querySelectorAll(".sub-category-btn").forEach((btn) => {
        btn.addEventListener("click", () => {
          clonedMenu
            .querySelectorAll(".sub-category-btn")
            .forEach((b) => b.classList.remove("active"));
          btn.classList.add("active");
        });
      });

      const mobileSearchInput = popup.querySelector("#rs-search-input");
      if (mobileSearchInput) {
        mobileSearchInput.addEventListener("keyup", function () {
          searchWhenReady(this.value);
          if (!this.value.trim()) resetToDefault();
        });
      }

      popup.classList.add("active");
    });
    if (closeBtn)
      closeBtn.addEventListener("click", () =>
        popup.classList.remove("active")
      );

    if (okBtn) {
      okBtn.addEventListener("click", () => {
        const mobileSearchInput = popup.querySelector("#rs-search-input");
        const searchQuery = mobileSearchInput
          ? mobileSearchInput.value.trim()
          : "";

        if (searchQuery) {
          searchWhenReady(searchQuery);
          if (menuToggleLabel)
            menuToggleLabel.textContent = `Search: ${searchQuery}`;
          if (searchInputDesktop) searchInputDesktop.value = searchQuery;
        } else {
          const activeBtnInPopup = popup.querySelector(
            ".sub-category-btn.active"
          );
          if (activeBtnInPopup) {
            const { category, tab } = activeBtnInPopup.dataset;
            const selector = category
              ? `.rs-menu .sub-category-btn[data-category="${category}"][data-tab="${tab}"]`
              : `.rs-menu .sub-category-btn[data-tab="${tab}"]:not([data-category])`;
            const originalBtn = document.querySelector(selector);
            if (originalBtn) {
              activateSubCategory(originalBtn);
            } else {
              resetToDefault();
            }
          } else {
            resetToDefault();
          }
        }
        popup.classList.remove("active");
      });
    }
  }
  if (searchInputDesktop) searchInputDesktop.value = "";

  const videoModal = document.getElementById("videoModal");
  const videoIframe = document.getElementById("videoIframe");
  const videoPlayer = document.getElementById("videoPlayer");

  function isShopifyVideo(videoUrl, videoType) {
    return videoType === "shopify" || videoUrl.includes("shopify.com");
  }

  function getYouTubeVideoId(videoUrl) {
    try {
      const url = new URL(videoUrl, window.location.href);
      const host = url.hostname.replace(/^www\./, "");

      if (host === "youtu.be") {
        return url.pathname.split("/").filter(Boolean)[0] || "";
      }
      if (!host.endsWith("youtube.com")) return "";

      if (url.pathname === "/watch") return url.searchParams.get("v") || "";

      const parts = url.pathname.split("/").filter(Boolean);
      if (["shorts", "embed", "live"].includes(parts[0])) return parts[1] || "";
    } catch (error) {
      return "";
    }

    return "";
  }

  function getExternalVideoEmbedUrl(videoUrl) {
    const youtubeId = getYouTubeVideoId(videoUrl);
    if (youtubeId) {
      const embedUrl = new URL(`https://www.youtube.com/embed/${youtubeId}`);
      embedUrl.searchParams.set("playsinline", "1");
      embedUrl.searchParams.set("rel", "0");
      embedUrl.searchParams.set("vq", "hd1080");
      return embedUrl.toString();
    }
    return videoUrl;
  }

  function upgradeYouTubePosterImages(container = document) {
    container.querySelectorAll("img[data-maxres-src]").forEach((image) => {
      if (image.dataset.maxresChecked === "true") return;
      image.dataset.maxresChecked = "true";

      const highResolutionImage = new Image();
      highResolutionImage.onload = () => {
        if (highResolutionImage.naturalWidth > 120) {
          image.src = image.dataset.maxresSrc;
        }
      };
      highResolutionImage.src = image.dataset.maxresSrc;
    });
  }

  upgradeYouTubePosterImages(document);

  function openVideoModal(videoUrl, videoType = "", posterUrl = "") {
    if (!videoModal || !videoUrl) return;

    closeVideoModal();

    if (videoPlayer && isShopifyVideo(videoUrl, videoType)) {
      if (videoIframe) videoIframe.style.display = "none";
      videoPlayer.style.display = "block";
      videoPlayer.poster = posterUrl;
      videoPlayer.src = videoUrl;
      videoPlayer.load();
      videoModal.style.display = "flex";
      videoModal.setAttribute("aria-hidden", "false");
      videoPlayer.play().catch(() => {});
      return;
    }

    if (!videoIframe) return;
    const embedUrl = getExternalVideoEmbedUrl(videoUrl);
    if (videoPlayer) videoPlayer.style.display = "none";
    videoIframe.style.display = "block";
    videoIframe.src = embedUrl;
    videoModal.style.display = "flex";
    videoModal.setAttribute("aria-hidden", "false");
  }

  function closeVideoModal() {
    if (!videoModal) return;
    if (videoIframe) videoIframe.src = "";
    if (videoPlayer) {
      videoPlayer.pause();
      videoPlayer.removeAttribute("src");
      videoPlayer.removeAttribute("poster");
      videoPlayer.load();
    }
    videoModal.style.display = "none";
    videoModal.setAttribute("aria-hidden", "true");
  }

  document.addEventListener("click", function (e) {
    const trigger = e.target.closest(".video-link");
    if (trigger) {
      e.preventDefault();
      openVideoModal(
        trigger.dataset.video,
        trigger.dataset.videoType,
        trigger.dataset.videoPoster
      );
    }
    if (e.target.closest(".video-modal .close")) {
      closeVideoModal();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && videoModal?.style.display === "flex") {
      closeVideoModal();
    }
  });
});
